import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import {withRouter, Link } from 'react-router-dom';
import classNames from 'classnames/bind';


import LargeFlightCard from '../LargeFlightCard/LargeFlightCard';
import Carousel from 'nuka-carousel';

import styles from './FlightCardListLarge.module.css';
import AirlineLogo from '../AirlineLogo/AirlineLogo';

// const airlines = ["airCanada", "jetSuite", "fiji", "surfair", "united", "virgin" ];
// const prices = [280, 340, 260, 340, 300, 250];
// const durations = ['14h 4   0m', '2h 0m', '1h 30m', '2h 30m', '1h 15m', '1h 45m'];
// const numberOfFlights = [1, 3, 4, 8, 3, 5];
// const departures = ['Fri 7:15am', 'Sat 8:30am', 'Thu 9:00am', 'Fri 9:45 am', 'Wed 2:00pm', 'Fri 3:45pm'];
// const arrivals = ['Mon 9:15am', 'Wed 9:30am', 'Sat 4:30pm', 'Fri 1:30pm', 'Sat 7:00am', 'Sun 9:30am'];

const cx = classNames.bind(styles);

class FlightCardListLarge extends Component {

	constructor(props){
		super(props);
		this.state = {
			activeIndex: 0
    }
	}

	renderLardCardDecorators = () => {
    const flight = this.props.flightData;
    const length = flight.cards.length;
		const decorators = [];
		for (var i = 0; i < length; i++){
			const isActive = (this.state.activeIndex === i);
			decorators.push(
        <div className={styles.largeCardCarouselDecorator} key={i} style={{backgroundColor: (isActive ? 'white' : 'gray'), opacity: (isActive ? 1 : 0.6)}}/>
			)
		}
		return decorators;
	}

	render(){
    const flight = this.props.flightData;
		const cards = [];
		for (let i = this.props.countOffset || 0; i < flight.cards.length; i++) {
      const card = flight.cards[i];
			const cardEl = (
			<Link to={`/flight/${i}/${this.props.direction}`} key={`flightCardLarge${i}`}>
				<LargeFlightCard video={card.video} image={card.image} text={card.text} />
			</Link>
			);
			cards.push(cardEl);
		}

    const flightCardLargeDuration = cx({
      flightCardLargeDuration: true,
    });

		return(
			<div className={styles.largeCardCarouselWrapper}>
        <div className={styles.carouselMask} >
          <Carousel
            afterSlide={(index) => { this.setState({ activeIndex: index}) }}
            renderBottomCenterControls={null}
            renderCenterLeftControls={null}
            renderCenterRightControls={null}
            initialSlideHeight={480}
            initialSlideWidth={335}
            cellSpacing={1}
            dragging>
            {cards}
          </Carousel>

          <div className={styles.largeCardCarouselDecoratorsWrapper}>
            <div className={styles.decoratorWrapper}>
              {this.renderLardCardDecorators()}
            </div>
            <div className={styles.flightCardLargeInfoContainer}>
              <div className={styles.flightCardLargeInfoRow}>
                <AirlineLogo airline={flight.airline} />
                <p className={styles.flightCardLargePrice}>roundtrip <span>${flight.price}</span></p>
              </div>

              <div className={styles.flightCardLargeInfoRow}>
                <p className={flightCardLargeDuration}>{flight.duration}</p>
                <p className={styles.flightCardLargeNumberOf}>{flight.numberOfFlights} {flight.numberOfFlights > 1 ? 'flights available' : 'flight available'}</p>
              </div>
            </div>
          </div>
        </div>
			</div>
		)
	}
}

FlightCardListLarge.propTypes = {
  flightData:propTypes.shape().isRequired,
}

const mapStateToProps = ({ main }) => ({
	isLongHaul: main.isLongHaul,
});

export default withRouter (connect(mapStateToProps)(FlightCardListLarge));



// WEBPACK FOOTER //
// ./src/components/FlightCardListLarge/FlightCardListLarge.jsx